module.exports = __webpack_public_path__ + "03_face.6fb62a59.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer1/03_face.png
// module id = Bb3m
// module chunks = 0